<template>
  <div class="filter-component-container">
    <div v-if="firstTitle" class="content">
      <div>
        <h3>{{ firstTitle }}</h3>
      </div>
      <select v-model="firstValueSelected">
        <option
          v-for="item in firstOptions"
          :key="item.id"
          :value="item.value"
          v-bind:selected="item.selected"
        >
          {{ item.name }}
        </option>
      </select>
    </div>

    <div v-if="secondTitle" class="content">
      <div>
        <h3>{{ secondTitle }}</h3>
      </div>
      <select v-model="secondValueSelected">
        <option
          v-for="item in secondOptions"
          :key="item.id"
          :value="item.value"
          v-bind:selected="item.selected"
        >
          {{ item.name }}
        </option>
      </select>
    </div>

    <div v-if="thirdTitle" class="content">
      <div>
        <h3>{{ thirdTitle }}</h3>
        <select v-model="thirdValueSelected">
          <option
            v-bind:selected="item.selected"
            v-for="item in thirdOptions"
            :key="item.id"
            :value="item.value"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="filter-button">
      <button @click="filterAllChanges">Filter</button>
    </div>

  </div>
</template>
<script>
export default {
  name: 'FilterJob',
  props: [
    'firstTitle',
    'secondTitle',
    'thirdTitle',
    'firstOptions',
    'secondOptions',
    'thirdOptions',
    'firstSelectedValue',
    'secondSelectedValue',
    'thirdSelectedValue'
  ],
  data() {
    return {
      firstValueSelected: this.firstSelectedValue,
      secondValueSelected: this.secondSelectedValue,
      thirdValueSelected: this.thirdSelectedValue
    };
  },
  methods: {
    filterAllChanges() {

      this.firstValueSelected === null &&
      this.secondValueSelected === null &&
      this.thirdValueSelected === null
      ?
       ''
      :
      this.$emit('filterHandler', {
        firstOption: this.firstValueSelected,
        secondOption: this.secondValueSelected,
        thirdOption: this.thirdValueSelected,
      });
    },
  },
};
</script>

<style scoped>
.filter-component-container {
  display: flex;
  flex-direction: row;
  padding: 30px 16px 30px 30px;
}
.filter-component-container .content {
  margin-right: 24px;
  width: 25%;
}
.filter-component-container .content h3 {
  font-family: "montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.25rem;
  color: var(--colorSecondary);
  padding-bottom: 16px;
}
.filter-component-container .content select {
  max-width: 100%;
  width: 100%;
  height: 40px;
  box-shadow: 0px 0px 4px 2px rgba(39, 31, 31, 0.15);
  border-radius: 3px;
  outline: none;
  padding: 10px;
  font-family: 'montserrat';
  font-size: 1rem;
  color: rgba(51, 52, 54, 0.7);
  line-height: 1.25rem;
  /* identical to box height */
  -webkit-appearance: auto;
  color: rgba(51, 52, 54, 0.7);
}
.filter-button {
  position: relative;
}
.filter-button button {
  position: absolute;
  width: 159px;
  height: 40px;
  background: var(--colorPrimary);
  bottom: 0;
  border-radius: 5px;
  color: var(--white);
  outline: none;
}
/* Responsiveness */
@media (min-width: 1201px) and (max-width: 1270px) {
  .filter-button button {
    width: 140px;
  }
}
@media (max-width: 1200px) {
  .filter-component-container {
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
  .filter-component-container .content {
    width: 40%;
    margin-right: 0;
    margin-bottom: 20px;
  }
  .filter-button button {
    position: relative;
  }
}

@media (max-width: 800px) {
  .filter-component-container {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  .filter-component-container .content {
    width: 100%;
    margin-bottom: 25px;
  }
  .filter-component-container .content select {
    width: 100%;
  }
  .filter-button button {
    position: relative;
    left: 0;
  }
}
</style>
